<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8" style="margin: 0 auto">
        <div class="searchPage">
          <!-- 搜索框 -->
          <div class="header">
            <!-- 顶部搜索框 -->
            <!-- <van-search
              v-model="searchVal"
              shape="round"
              placeholder="请输入直播名称"
              @input="search(searchVal)"
            /> -->
            <input
              v-model="searchVal"
              placeholder="请输入直播名称"
              @input="search(searchVal)"
              autocomplete="off"
              class="search-box"
            />
            <span class="cancel" @click="cancel">取消</span>
          </div>
          <!-- 栏目列表 -->
          <div v-show="searchVal !== ''" class="infoItem">
            <!-- 图文项目内容 -->
            <div
              class="infoItemContent"
              v-for="(item, index) in dataList"
              :key="index"
              @click="getDetail(item.liveId)"
            >
              <!-- 图片 -->
              <div class="liveImg">
                <img
                  class="infoItemImg"
                  :src="item.liveCoverImg"
                  alt="暂无图片"
                />
                <div class="liveStatus">
                  {{
                    item.liveStatus === 0
                      ? '即将直播'
                      : item.liveStatus === 1
                      ? '直播中'
                      : '历史直播'
                  }}
                </div>
              </div>
              <!-- 图文项目文本 -->
              <div class="inforItemText">
                <!-- 图文项目标题 -->
                <div class="infoItemTitle">
                  <a>{{ item.liveName }}</a>
                </div>
                <!-- 图文项目讲师 -->
                <div class="infoItemDes">
                  <p>{{ item.liveLecturers }}</p>
                </div>
                <!-- 简介 -->
                <div class="infoItemPrice">
                  <span class="price" v-if="item.livePay === 0"
                    >¥{{ item.liveAmt.toFixed(2) }}</span
                  >
                  <span class="free" v-if="item.livePay === 1">免费</span>
                </div>
                <div class="infoItemDes2" v-if="item.liveStatus === 0">
                  <span
                    >开始时间：{{ item.liveStartTime.substring(0, 19) }}</span
                  >
                </div>
                <div class="infoItemDes2" v-if="item.liveStatus === 1">
                  <span>结束时间：{{ item.liveEndTime.substring(0, 19) }}</span>
                </div>
              </div>
            </div>
            <div
              v-if="pageIndex < dataForm.totalPage"
              style="
                text-align: center;
                font-size: 12px;
                color: #666;
                margin-top: 10px;
              "
              @click="loadMore(searchVal)"
            >
              点击加载更多...
            </div>
            <div
              v-else
              style="
                text-align: center;
                font-size: 12px;
                color: #666;
                margin-top: 10px;
              "
            >
              暂无更多直播...
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 搜索绑定
      searchVal: '',
      dataList: [],
      dataForm: {
        currPage: 0,
        pageSize: 0,
        totalCount: 0,
        totalPage: 0,
      },
      pageIndex: 1,
    }
  },
  mounted() {
    this.noShare()
  },
  methods: {
    loadMore(catName) {
      this.pageIndex++
      if (this.pageIndex <= this.dataForm.totalPage) {
        this.getDataList(catName)
      }
    },
    getDetail(liveId) {
      this.$router.push({
        path: '/details',
        query: { liveId: liveId },
      })
    },
    // 获取数据列表
    getDataList(catName) {
      // this.searchVal = catName
      if (!this.searchVal) {
        return
      }
      const mobile = localStorage.getItem('mobile')
      this.$http({
        url: '/live/live/queryList/',
        method: 'get',
        params: {
          page: 1,
          limit: 100,
          liveName: this.searchVal,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.data.list
          this.dataForm.pageSize = data.data.pageSize
          this.dataForm.totalCount = data.data.totalCount
          this.dataForm.totalPage = data.data.totalPage
          this.dataForm.currPage = data.data.currPage
        } else {
          this.dataList = []
          this.pageIndex = 1
        }
      })
    },
    search(searchVal) {
      this.dataList = []
      var canClick = true
      if (canClick) {
        canClick = false
        this.getDataList(searchVal)
      }
    },
    cancel() {
      this.searchVal = ''
      this.dataList = []
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.infoItemDes2 {
  // line-height: 15px;
  color: #666;
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  // margin: 5px 0;
}
.searchPage {
  margin: 1rem 2rem;
}
.header {
  background-color: #fff;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  .search-box {
    width: 82%;
    height: 36px;
    font-size: 14px;
    border-radius: 16px;
    border: none;
    background-color: #eee;
    padding-left: 14px;
    outline: medium;
    margin-right: 8px;
  }
  span {
    color: $theme-color;
  }
}
/* 每一个图文项目的外层 */
a {
  text-decoration: none;
  color: #333;
}
.inforItemText {
  margin-left: 2rem;
  width: 65%;
  // line-height: 35px;
}
/* 图文项目的标题信息 */
.infoItemTitle {
  font-size: $font-title2;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: -o-ellipsis-lastline;
}
/* 图文项目的内容信息(弹性布局) */
.infoItemContent:last-child {
  border-bottom: 0;
}
.infoItemContent {
  display: flex;
  align-items: center;
  padding: 0.2rem 0;
  margin: 0.2rem 0;
  width: 100%;
  border-bottom: 1px solid #eee;
  .liveImg {
    position: relative;
    .liveStatus {
      position: absolute;
      right: 0;
      bottom: 0;
      color: #fff;
      padding: 2px 1rem;
      border-radius: 1rem;
      font-size: 12px;
      background-color: rgba($color: #000000, $alpha: 0.8);
    }
  }
}
/* 图文项目的内容信息--图片 */
.infoItemImg {
  width: 100px;
  height: 75px;
  border-radius: 5px;
}
/* 图文项目的内容信息--简介 */
.infoItemDes {
  // line-height: 20px;
  color: #666;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin: 5px 0;
}
.infoItemPrice {
  font-size: 14px;
  color: #999;
  padding-bottom: 5px;
  .free {
    padding: 2px;
    margin-right: 1rem;
    font-size: 12px;
    background-color: $theme-color;
    border-radius: 3px;
    color: #fff;
  }
  .price {
    padding: 2px;
    margin-right: 1rem;
    color: $theme-color;
    span {
      margin-left: 5px;
    }
  }
}
</style>
